<template>
  <div v-if="basketCount === 0" class="max-w-[350px] text-md">
    <SFTooltipInfo
      :title="$t('tooltip.basket.title_empty')"
      :description="$t('tooltip.basket.description')"
    />
  </div>
  <SFHeaderBasketInfo v-else />
</template>

<script setup lang="ts">
import { useBasket } from '#storefront/composables'
import SFTooltipInfo from '~/components/ui/SFTooltipInfo.vue'
import SFHeaderBasketInfo from '~/components/layout/headers/basket/SFHeaderBasketInfo.vue'

const { count: basketCount } = useBasket()
</script>
